<template>
  <div class="type">
    <div class="type__bg"></div>
    <div class="type__main container">
      <section class="type__title">
        <img :src="dataPage[$route.params.type].url" alt="">
        <p>{{dataPage[$route.params.type].des}}</p>
      </section>
      <section class="typelist">
        <router-link :to="{ name: 'type', params: { name: data.name }}" v-for="(data,index) in dataPage[$route.params.type].dataList" :key="index">
          <component-apply-type :class="{'active':$route.params.name===data.name}" :data="data" @listen-is-show="showChild"></component-apply-type>
        </router-link>
      </section>
        <component-type-content :content="apiData[$route.params.name]"></component-type-content>
    </div>
    <component-application-access v-on:listen-is-show="showChild" :is-show="isShow" :type="'apply'"></component-application-access>
  </div>
</template>
<script>
/**
 * 分类页
 *
 * @author dongyang
 */
import ApplyType from '@/components/ApplyType'
import TypeContent from '@/components/TypeContent'
import ApplicationAccess from '@/components/ApplicationAccess'
export default {
  name: 'Type',
  data () {
    return {
      isShow: false,
      dataPage: {
        jinse: {
          url: require('../assets/images/type_logo.svg'),
          des: '金色财经是多家搜索引擎新闻源合作媒体，并且和和讯、腾讯、猎云、新浪、网易、今日头条、一条新闻等数十家财经及科技媒体达成内容合作。截止到2017年7月，金色财经已有1000余家企业、个人自媒体、行情分析师入驻平台，每日200篇以上的内容输出；近3月以来，金色财经日均UV(独立访客)35万，高峰时100万，已成为区块链行业最具影响力的服务平台之一。',
          dataList: [
            {
              url: require('../assets/images/typelist1.svg'),
              title: '文章',
              des: '海量资讯，极速直达',
              name: 'article'
            },
            {
              url: require('../assets/images/typelist2.svg'),
              title: '快讯',
              des: '7*24小时要闻，快速实时',
              name: 'lives'
            }
            // {
            //   url: require('../assets/images/typelist3.svg'),
            //   title: '行情',
            //   des: '数字货币价格实时监控',
            //   name: 'market'
            // }
          ]
        },
        hotnode: {
          url: require('../assets/images/hotnodelogo.svg'),
          des: 'Hotnode是区块链行业全球化数据服务和协作平台，致力于成为区块链的Crunchbase+Bloomberg。通过数据挖掘和处理组建行业数据库，在此基础上进行模型建立和数据分析，设计AI数据产品，并对外进行API输出，打造行业基础设施；通过提供工具，服务行业各类角色，吸引入驻，形成一定粘性，成为区块链行业的全球化平台级产品。',
          dataList: [
            {
              url: require('../assets/images/typelist4.svg'),
              title: '项目库',
              des: '一、二级市场最全数据',
              name: 'project'
            }
          ]
        }
      },
      apiData: {
        article: {
          left: {
            rules: '签名规则',
            api: '文章API',
            demo: 'PHP Demo'
          },
          content: {
            rules: `
<h3>签名规则：</h3>
签名时的字符一律采用UTF-8编码。
参与加密的参数按照a-z排序，签名MD5必须是小写字母
签名时的字符一律采用UTF-8编码。
参与加密的参数按照a-z排序，签名MD5必须是小写字母
签名必须参数：
access_key：访问accessKey
date：请求时间戳（秒）
sign：签名字段 （小写）
例如请求参数：
access_key=67086e25c42a89fecfc3d724881c52f6
date=1502280920
last_id=32840
签名添加（请求参数不添加）：
secret_key=71197b858ceaedd3
排序并使用&连接后：
access_key=67086e25c42a89fecfc3d724881c52f6&date=1502280920&last_id=
32840&secret_key=71197b858ceaedd3
通过md5获得签名：322993bb8570dd095c5f91e638f07f75`,
            api: `
<h3>文章API：</h3>
<h4>请求地址：GET http://api.coinmeta.info/topic/list</h4><h4>请求参数：</h4>last_id : （可选）分页游标，文章ID。不传则返回最新一批。
        配合 flag 翻页：不填 flag 或 flag=up 时返回 id 大于 last_id 的文章（翻页传上一批最大 id）；
        flag=down 时返回 id 小于 last_id 的文章（翻页传上一批最小 id）
flag : （可选）翻页方向，取值 up / down。down=取比 last_id 更旧的文章（往历史翻）；
        up 或不填=取比 last_id 更新的文章（默认行为）
article_id : （可选）指定文章ID（即响应里的 id 值）。传了则只返回该篇文章，忽略 last_id / flag / tag_names 等翻页筛选参数
limit : （可选）返回条数，默认 10，取值范围 1-50（超出自动截断到该区间）
tag_names : （可选）按标签名称筛选文章，多个用英文逗号分隔（如 比特币,以太坊）。
        名称需与站内标签完全一致；多个标签为"或"关系（命中任一即返回）；分页方式同上（last_id / flag）
注：以上请求参数（article_id / flag / last_id / limit / tag_names）传了都要一并参与签名<h4>返回参数：</h4><pre><code>
[
  {
    id: 32843,   // 文章ID
    url: "http://www.jinse.com/bitcoin/32843.html",  // 文章地址
    title: "寻找金融新势能 ——2017金融科技夏季峰会",  // 文章标题
    summary: "金融科技是利用技术变革，助力金融业创新发展。",  // 文章摘要
    content: "活动内容：金融科技是利用技术变革",    // 文章内容(HTML)
    published_at: "2017/6/14 19:43",    // 发表时间(友好格式)
    published_time: "2017-06-14 19:43:00",  // 发表时间(标准格式 Y-m-d H:i:s)
    resource: "金色财经",    // 来源
    resource_url: "",   // 来源地址
    author: "洛比特奇霍",    // 作者
    thumbnail: "http://img.jinse.com/85964_image1.png",  // 文章缩略图
    is_attribute_exclusive: 0,  // 属性：独家(1是/0否)
    is_attribute_depth: 0,      // 属性：深度(1是/0否)
    is_attribute_spread: 0      // 属性：推广(1是/0否)
  }
]
</code></pre>`,
            demo: `
<h3>PHP Demo：</h3>
<pre><code class="php">
&lt?php
  $accessKey = 'your access key';
  $secretKey = 'your secret key';

  $httpParams = array(
    'access_key' => $accessKey,
    'date' => time()
    // 以下均为可选参数，加入后都会一并参与签名：
    // 'limit' => 20,               // 返回条数，默认10，最大50
    // 'last_id' => 32000,          // 分页游标，见"请求参数"说明
    // 'flag' => 'down',            // 翻页方向 up/down，见"请求参数"说明
    // 'article_id' => 3725227,     // 指定文章ID，只返回该篇
    // 'tag_names' => '比特币,以太坊', // 按标签名称筛选，多个用英文逗号分隔
  );

  $signParams = array_merge($httpParams, array('secret_key' => $secretKey));

  ksort($signParams);
  $signString = http_build_query($signParams);

  $httpParams['sign'] = strtolower(md5($signString));

  $url = 'http://api.coinmeta.info/topic/list?'.http_build_query($httpParams);
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

  $curlRes = curl_exec($ch);
  curl_close($ch);

  $json = json_decode($curlRes, true);

  var_dump($json);
      </code></pre>`
          }
        },
        lives: {
          left: {
            api: '快讯API',
            demo: 'PHP Demo'
          },
          content: {
            api: `
<h3>快讯API：</h3>
<h4>请求地址：GET http://api.coinmeta.info/live/list</h4><h4>请求参数：</h4>limit : （可选）获取的条数限制，取值（1-200），默认 20
id : （可选）从第几条快讯ID进行查询，默认 0
flag : （可选）结合id，是向上（大于）查询还是向下（小于）查询，取值up、down，默认down
默认值 : id=0&flag=down，获取最新的 {limit} 条快讯记录
使用 : id=100&flag=down, 获取小于id 100 的 {limit} 条快讯记录，适用于获取历史快讯
使用 : id=200&flag=up, 获取大于id 200 的 {limit} 条快讯记录，适用于获取最新快讯（注意，
依然会返回小于id为200的数据）<h4>返回参数：</h4><pre><code>
{
  news: 20, // 新的快讯数量
  count: 20, // 总的快讯数量
  top_id: 64, // 结果中最新的快讯id
  bottom_id: 45, // 结果中最后的快讯id
  list: [
    {
      date: "2017-11-25", // 快讯按天汇总的日期
      lives: [
        {
          id: 64,  // 快讯id
          content: "快讯内容",
          link_name: "",  // 链接名称
          link: "",  // 链接地址
          grade: 4,  // 星级 （5、4、3、2、1、0）
          highlight_color: "", // 是否标红； red 标红
          images: [ // 图片地址，分别对应原图地址、缩略图地址和图片大小
            {
              url: "http://domain.com/14195.png",
              thumbnail: "http://domain.com/14195_live.png",
              height: 100,
              width: 100
            },
            {
              url: "http://domain.com/14195.png",
              thumbnail: "http://domain.com/14195_live.png",
              height: 100,
              width: 100
            }
          ],
          created_at: 1511614848, // 快讯时间
          up_counts: 0, // 看涨数量
          down_counts: 0, // 看跌数量
          zan_status: null // *忽略
        }
      ]
    }
  ]
}
            </code></pre>`,
            demo: `
<h3>PHP Demo：</h3>
<pre><code class="php">
&lt?php
  $accessKey = 'your access key';
  $secretKey = 'your secret key';

  $httpParams = array(
    'access_key' => $accessKey,
    'date' => time()
  );

  $signParams = array_merge($httpParams, array('secret_key' => $secretKey));

  ksort($signParams);
  $signString = http_build_query($signParams);

  $httpParams['sign'] = strtolower(md5($signString));

  $url = 'http://api.coinmeta.info/topic/list?'.http_build_query($httpParams);
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

  $curlRes = curl_exec($ch);
  curl_close($ch);

  $json = json_decode($curlRes, true);

  var_dump($json);
            </code></pre>`
          }
        },
        market: {
          left: {
            supportpair: '交易对信息',
            singlepair: '交易对行情',
            marketpair: '交易所行情',
            kline: 'k线数据',
            top100: '币值排名'
          },
          content: {
            supportpair: `
<h3>交易对信息：</h3>
<h4>请求地址：GET http://api.coinmeta.info/api/v1/symbols</h4><h4>返回参数：</h4><pre><code>
[
  {
    "name": "BTCUSD",   // 交易对名称
    "name_cn": "比特币", // 交易币种中文
    "name_en": "Bitcoin",  // 交易币种英文
    "ticker": "BITFINEX:BTCUSD",  // 交易所与交易对信息
    "currency": "BTC",    // 交易币种简称
    "exchangeTraded": "Bitfinex",  // 交易所
    "exchangeListed": "Bitfinex",  // 交易所
    "timezone": "Asia/Shanghai",  // 时间地区
    "minmov": 1,
    "pricescale": 100
  },
]
</code></pre>`,
            singlepair: `
<h3>交易对行情：</h3>
<h4>请求地址：GET http://api.coinmeta.info/api/v1/tick/{ticker}?unit=cny</h4><h4>请求参数：</h4>ticker : 交易所与交易对信息
例如：BITFINEX:BTCUSD unit : 转换价格，默认 CNY (人民币)，可选：base（原价格） usd (美元)<h4>返回参数：</h4><pre><code>
{
  "ticker" : "HUOBIPRO:BTCUSDT",  // Ticker名称
  "exchangeName" : "HuobiPro",   // 交易所名称
  "base" : "BTC",   // 交易币种
  "currency" : "USDT",  // 兑换币种
  "symbol" : "BTCUSDT",   // 交易对儿标识
  "high" : 61512.12713304667350,    // 最高价
  "open" : 58970.63530801362825,   // 开盘价
  "close" : 59065.33243911680550,   // 收盘价（最新价）
  "low" : 57920.51289144851775,   // 最低价
  "vol" : 22373.79282497,   // 成交量
  "degree" : 0.16058400,   // 涨跌幅
  "dateTime" : 1524630942000   // 更新时间戳（微妙）
}
              </code></pre>`,
            marketpair: `
<h3>交易所行情：</h3>
<h4>请求地址：GET http://api.coinmeta.info/api/v1/ticks/{exchange}?unit=cny</h4><h4>请求参数：</h4>exchange : 交易所信息
例如：BITFINEX unit : 转换价格，默认 CNY (人民币)，可选：base（原价格） usd (美元)<h4>返回参数：</h4><pre><code>
[
{
  "ticker" : "HUOBIPRO:BTCUSDT",  // Ticker名称
  "exchangeName" : "HuobiPro",   // 交易所名称
  "base" : "BTC",   // 交易币种
  "currency" : "USDT",  // 兑换币种
  "symbol" : "BTCUSDT",   // 交易对儿标识
  "high" : 61512.12713304667350,    // 最高价
  "open" : 58970.63530801362825,   // 开盘价
  "close" : 59065.33243911680550,   // 收盘价（最新价）
  "low" : 57920.51289144851775,   // 最低价
  "vol" : 22373.79282497,   // 成交量
  "degree" : 0.16058400,   // 涨跌幅
  "dateTime" : 1524630942000   // 更新时间戳（微妙）
},
...
]
            </code></pre>`,
            kline: `
<h3>k线数据：</h3>
<h4>请求地址：GET http://api.coinmeta.info/api/v1/klines/{ticker}/{period}</h4><h4>请求参数：</h4>ticker : 交易所与交易对信息
例如：BITFINEX:BTCUSD period ：K线周期，支持的值：M1/M5/M15/M30/H1/H4/D1/W1/MONTH ,
分别对应：1分钟、5分钟、15分钟、30分钟、1小时、4小时、1天、1周、1月
<h4>返回参数：</h4><pre><code>
[
  {
    "symbol": "BTCUSDT",  // 交易对儿名称
    "dateTime": 1517898060000, // 时间
    "high": 41922.66139657,   // 最高价
    "open": 41922.66139657,  // 开盘价
    "low": 41700.92226613,   // 最低价
    "close": 41798.22134387,  // 收盘价
    "vol": 7.64586251   // 交易量
  },
  ...
]
            </code></pre>`,
            top100: `
<h3>币值排名：</h3>
<h4>请求地址：GET http://api.coinmeta.info/api/v1/currency/ranks</h4><h4>返回参数：</h4><pre><code>
[
  {
    "currency": "BTC",  //币种名称
    "name": "比特币",
    "describe": "比特币（BitCoin）的概念最初由中本聪在2009年提出，
    根据中本聪的思路设计发布的开源软件以及建构其上的P2P网络。
    是一种P2P形式的数字货币。点对点的传输意味着一个去中心化的支付系统。
    比特币与其他虚拟货币最大的不同，是其总数量非常有限，具有极强的稀缺性。该货币系统曾在
    4年内只有不超过1050万个，之后的总数量将被永久限制在2100万个。",  // 币种描述
    "iconUrl": "http://www.jinse.com/static/phenix/img/coin/BTC.png",// 币种图标
    "price": 41778.35,  // 价格
    "vol": 90094794019.62, // 交易额
    "change": -22.63,  // 涨跌幅
    "maxSupply": 21000000,  // 发行量
    "supply": 16848937,   // 流通量
    "marketCap": 703920758469.63,  // 总市值
    "updateTime": 1517901551000  // 更新时间
},
  ...
]
  </code></pre>`
          }
        },
        project: {
          left: {
            domain: 'API域名',
            page: '分页参数',
            error: '错误提示',
            list: '项目列表',
            detail: '项目详情',
            notice: '上所公告',
            noticedetail: '上所公告详情'
          },
          content: {
            domain: `
<h3>API 域名</h3>
<h4>https://api.open.hotnode.cn</h4>`,
            page: `
<h3>分页参数</h3>
<h4>请求参数 (HTTP GET)</h4>per-page：每页容量，类型int，上限300
page：请求页码，类型int
<h4>响应参数 (HTTP HEADER)</h4>x-pagination-current-page：当前页码，类型int
x-pagination-page-count：分页总页数，类型int
x-pagination-per-page：每页容量，类型int
x-pagination-total-count：条目总数，类型int`,
            error: `
<h3>错误提示</h3>
<pre><code>
HTTP/1.1 404 Not Found
Server: nginx
Date: Wed, 14 Nov 2018 02:18:00 GMT
Content-Type: application/json; charset=UTF-8

{
    "name": "Not Found",
    "message": "项目不存在或已下架",
    "code": 0,
    "status": 404
}
            </code></pre>`,
            list: `
<h3>项目列表</h3>
<h4>地址     /v1/coins</h4><h4>方法     HTTP/1.1 GET</h4><h4>响应参数：</h4>Id：编号，类型int
Name：名称，类型string
Symbol：简称，类型string
Icon：图标，类型url
Homepage：官网，类型url
Description：简介，类型string
updated_at：信息更新时间，类型timestamp，例如“1542098140”
finance_start_at：募资开始时间，类型timestamp，例如“1542098140”
finance_end_at：募资结束时间，类型timestamp，例如“1542098140”
finance_status：募资状态，类型string，例如“即将开始”，注：共有未设定、即将开始、进行中、已结束4中状态
tags：标签列表，类型array
<h4>响应示例</h4><pre><code>
[
    {
        "id": 1,
        "name": "Bitcoin",
        "symbol": "btc",
        "icon": "https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1510040391",
        "homepage": "http://www.bitcoin.org",
        "description": "这里是简介信息",
        "updated_at": 1542098140,
        "finance_start_at": 1542098140,
        "finance_end_at": 1542098140,
        "finance_status": "即将开始",
        "tags": [
            {
                "id": 21,
                "name": "社交通讯"
            }
        ]
    }
]
            </code></pre>`,
            detail: `
<h3>项目详情</h3><h4>地址     /v1/coins/{id}</h4><h4>方法     HTTP/1.1 GET</h4><h4>响应参数</h4>id：编号，类型int
name：名称，类型string，例如“Bitcoin”
symbol：Symbol，类型string，例如“BTC”
icon：图标，类型url
homepage：官网，类型url
description：简介，类型string，例如“这里是简介信息”
updated_at：信息更新时间，类型timestamp，例如“1542098140”
finance_start_at：募资开始时间，类型timestamp，例如“1542098140”
finance_end_at：幕资结束时间，类型timestamp，例如“1542098140”
finance_status：幕资状态，类型string，例如“即将开始”
tags：标签列表，类型array
regions：国别，类型array
members：成员，类型array
white_papers：白皮书，类型array
investment_orgs：投资机构，类型array
<h4>响应示例</h4><pre><code>
{
    "id": 1,
    "name": "Bitcoin",
    "symbol": "btc",
    "icon": "https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1510040391",
    "homepage": "http://www.bitcoin.org",
    "description": "这里是简介信息",
    "updated_at": 1542098140,
    "finance_start_at": 1542098140,
    "finance_end_at": 1542098140,
    "finance_status": "即将开始",
    "tags": [
        {
            "id": 21,
            "name": "社交通讯"
        }
    ],
    "regions": [
        {
            "id": 1,
            "name": "中国"
        },
        {
            "id": 2,
            "name": "美国"
        }
    ],
    "members": [
        {
            "id": 170504,
            "name": "Juan Carlos Ruiz",
            "title": "CEO",
            "profile_pic": "http://hotnode-production-file.oss-cn-beijing.aliyuncs.com/profile_pic/20181106/9HSVL7ZHfrbHriYVcpfaRshKB1tLepBJn4j5uqYLljUT2l.jpeg",
            "introduction": "这里是成员简介",
        }
    ]
    "white_papers": [
        {
            "id": 6337,
            "filename": "白皮书",
            "path_url": "http://hotnode-production-file.oss-cn-beijing.aliyuncs.com/white_papers/20180918/AIHQU0zCTcjGbiPiyANLBbXLdXi5AgI7zFyDqguXON2LNx.pdf",
            "created_at": 1537216321,
            "comment": "这里是一些说明信息"
        }
    ],
    "investment_orgs": [
        {
            "id": 155,
            "name": "投资机构"
        }
    ],
    "rating_orgs": [
        {
            "id": 8378,
            "rating_name": "评级机构",
            "grade": "A+"
        }
    ]
}
            </code></pre>`,
            notice: `
<h3>上所公告</h3>
<h4>地址     /v1/news</h4><h4>方法     HTTP/1.1 GET</h4><h4>请求参数</h4>coin_id：项目编号，类型int，例如“1”，备注：可选参数
<h4>响应参数</h4>Id：编号，类型int
coin_id：项目编号，类型int，例如“2069”
coin_name：项目，类型string，例如“Bitcoin”
title：主标题，类型string
logo：图标，类型utl
subtitle：副标题，类型string
content：简要内容不要超过64个字符，类型string，备注text/plain
original_link：原始链接，类型url
type：内容类型，类型string，例如“上所公告”，备注主要含上所公告,快讯,交易所公告,站内公告
created_at：生成时间，类型timestamp，例如“1540108220”
<h4>响应示例</h4><pre><code>
[
    {
        "id": 39759,
        "coin_id": 2069,
        "coin_name": "Bitcoin",
        "title": "主标题",
        "logo": "http://domain.com/pic.png",
        "subtitle": "副标题",
        "content": "纯文本简略内容(64字符以内)",
        "original_link": "https://mxc-exchange.zendesk.com/hc/zh-cn/articles/360018512511",
        "type": "上所公告",
        "created_at": 1540108220
    }
]
            </code></pre>`,
            noticedetail: `
<h3>上所公告详情</h3>
<h4>地址     /v1/news/{id}</h4><h4>方法     HTTP/1.1 GET</h4><h4>响应参数</h4>id：编号，类型int
coin_id：项目编号，类型int，例如“2069”
coin_name：项目，类型string，例如“Bitcoin”
title：主标题，类型string
logo：图标，类型url
subtitle：副标题，类型string
content：富文本详细内容，类型string，备注text/html
original_link：原始链接，类型url
type：内容类型，类型string，例如“上所公告”，备注含上所公告,快讯,交易所公告,站内公告
<h4>响应示例</h4><pre><code>
[
    {
        "id": 39759,
        "coin_id": 2069,
        "coin_name": "Bitcoin",
        "title": "主标题",
        "logo": "http://domain.com/pic.png",
        "subtitle": "副标题",
        "content": "富文本详内容",
        "original_link": "https://mxc-exchange.zendesk.com/hc/zh-cn/articles/360018512511",
        "type": "上所公告",
        "created_at": 1540108220
    }
]
            </code></pre>`

          }
        }
      }
    }
  },
  methods: {
    showChild (data) {
      this.isShow = data
    }
  },
  components: {
    'component-apply-type': ApplyType,
    'component-type-content': TypeContent,
    'component-application-access': ApplicationAccess
  },
  mounted () {
    window.addEventListener('scroll', () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (document.querySelector('.content')) {
        let titlepos = document.querySelector('.content').offsetTop - 73
        let title = document.querySelector('.content__left')
        if (scrollTop > titlepos) {
          title.classList.add('leftfix')
        } else {
          title.classList.remove('leftfix')
        }
      }
    })
    // window.onhashchange = function () {
    //   document.documentElement.scrollTop = document.querySelector(location.hash).ownerDocument.defaultView.pageYOffset - 73
    // }
  }
}
</script>
<style lang="scss" scoped>
.type__bg {
  height: 240px;
  background: url('../assets/images/typebg.jpeg') no-repeat center top;
  background-size: cover;
}
.type__main {
  margin-top: -105px;
}
.type__title {
  position: relative;
  width: 970px;
  height: 150px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 20px 0px rgba(59, 59, 67, 0.12);
  img {
    position: absolute;
    top: 60px;
    left: 50px;
  }
  p {
    margin-left: 270px;
    padding-top: 15px;
    width: 670px;
    height: 120px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(33, 33, 42, 1);
    line-height: 30px;
  }
}
.typelist {
  margin-top: 60px;
  display: flex;
  justify-content:flex-start;
    .apply {
      margin-right: 30px;
      margin-bottom: 45px;
    }
    .apply:nth-child(4n) {
      margin-right: 0;
    }
}
.active {
  box-shadow: 0px 6px 20px 0px rgba(40, 144, 236, 0.2);
  border: 2px solid #2890ec;
}
</style>
